// @flow

export const ErrorCodes = Object.freeze({
  E_RESTRICTED_LIMIT: 1413,
});
export type ErrorCode = $Values<typeof ErrorCodes>;
